import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);


//TODO: Handle the case where user adds none pdf files
//TODO: Handle the case where user adds pdf files with not related content
//TODO: Maybe an error page